import { JsonObject, JsonProperty } from 'json2typescript';
import { Service } from '../services/service';

export enum PaymentPlanEnum {
    MONTHLY = 1,
    QUARTERLY = 3,
    SEMIANNUAL = 6,
    ANNUAL = 12
}

@JsonObject('ClientContract')
export class ClientContract {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('client_id', Number, true)
    clientId: number = undefined;

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate = null;

    @JsonProperty('relationship', Service, true)
    relationship = null;

    @JsonProperty('services', [Service], true)
    services: Service[] = [];

    @JsonProperty('payment_plan', Number, true)
    paymentPlan: PaymentPlanEnum = null;

    @JsonProperty('price', Number, true)
    price = undefined;

    @JsonProperty('start_date', String, true)
    startDate = null;

    @JsonProperty('end_date', String, true)
    endDate = null;

    get isClubs() {
        return this.relationship && this.relationship.code === '1.1';
    }

    get isRetainer() {
        return this.relationship && this.relationship.code === '1.2';
    }

    get isCaseByCase() {
        return this.relationship && this.relationship.code === '1.3';
    }

    get getPaymentPlan() {
        return PaymentPlanEnum[this.paymentPlan];
    }
}

